import { concat } from '@ember/helper';
import orElse from 'volta/helpers/or-else';
import BvIcon from 'volta/components/bv-icon';

import type { TOC } from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';

interface BvInlineErrorSignature {
  Args: {
    dataTestInlineError?: string;
    dataTestInlineErrorIcon?: string;
    fieldID?: string;
    hideIcon?: boolean;
    isWarning?: boolean;
    message?: ContentValue;
  };
  Element: HTMLDivElement;
}

const BvInlineErrorComponent: TOC<BvInlineErrorSignature> = <template>
  {{#if @message}}
    <div
      class='bv-inline-error{{if @isWarning " bv-inline-error--warning"}}'
      id={{concat @fieldID 'Error'}}
      data-test-inline-error={{orElse @dataTestInlineError true}}
      ...attributes
    >
      {{#unless @hideIcon}}
        <BvIcon
          @color={{if @isWarning 'orange' 'red'}}
          @glyph={{if @isWarning 'warning-outline' 'alert-circle-outline'}}
          class='bv-inline-error__icon'
          data-test-inline-error-icon={{orElse @dataTestInlineErrorIcon true}}
        />
      {{/unless}}
      {{@message}}
    </div>
  {{/if}}
</template>;

export default BvInlineErrorComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvInlineError: typeof BvInlineErrorComponent;
    'bv-inline-error': typeof BvInlineErrorComponent;
  }
}
